import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  Card,
  CardContent,
  Divider,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";
import "./Table.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from '@mui/icons-material/Edit';
import { Input } from "@mui/joy";
import { Get, GetChat } from "../../services/apiServices";
import { networkUrls } from "../../services/networkurls";
import { count } from "console";

const DocumentsTable = ({ triggerGetCall, open, setOpen,tableName,type,setData }: any) => {
  const [projectsLoading, setProjectLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  
  const[rows,setRows]=useState([]);
  const [documents, setDocuments] = useState([]);
  const[industryTrack,setIndustryTrack]=useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width:768px)");

  const getProjectDocuments = async (searchQuery = "") => {
    try {
      setProjectLoading(true);
      const baseUrl = `${networkUrls.projectDocuments}?page=${page + 1
        }&page_size=${pageSize}`;
      const fullUrl =
        searchQuery.length >= 3
          ? `${baseUrl}&search=${encodeURIComponent(searchQuery)}`
          : baseUrl;

      const response = await Get(fullUrl, true);

      if (response?.status === 200) {
        const docs = response?.data?.documents || [];
      setDocuments(docs);
      setTotalCount(response?.data?.total || 0);

      const mappedRows = docs.map((doc: any, index: number) => ({
        id: index + 1 + page * pageSize,
        doc_id: doc?.doc_id || "----",
        filename: doc?.filename   || "----",
        clientname: doc.organizations?.[0]
          ? doc.organizations[0].charAt(0).toUpperCase() +
            doc.organizations[0].slice(1)
          : "----",
      }));
      setRows(mappedRows);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setProjectLoading(false);
    }
  };

   const getIndustryTrack = async (searchQuery = "") => {
  try {
    setProjectLoading(true);
    const baseUrl = `${networkUrls.fetchIndustryTrack}?page=${page + 1}&page_size=${pageSize}`;
    const fullUrl =
      searchQuery.length >= 3
        ? `${baseUrl}&search=${encodeURIComponent(searchQuery)}`
        : baseUrl;

    const response = await Get(fullUrl, true);

    if (response?.status === 200) {
      const trackData = response?.data?.data || [];
      setIndustryTrack(trackData);
      setTotalCount(response?.data?.total || 0);

        const mappedRows = trackData.map((track: any, index: number) => ({
        id: index + 1 + page * pageSize,
        industry_track_id: track?.["industry_track_id"] || "----",
        industry_name: track?.["Industry Name"] || "----",
        manager: track?.["Manager"] || "----",
        spoc1: track?.["SPOC 1"] || "----",
        spoc2: track?.["SPOC 2"] || "----",
        spoc3: track?.["SPOC 3"] || "----",
        members: track?.Members
          ? track.Members.split(",").map((m: string) => m.trim())
          : [],
      }));
      setRows(mappedRows); 
    }
  } catch (error) {
    console.error("Error fetching industry track:", error);
  } finally {
    setProjectLoading(false);
  }
};

const getUsers=async(searchQuery="")=>{
  try {
    setProjectLoading(true);
     const baseUrl = `/api${networkUrls.users}?page=${page + 1
        }&page_size=${pageSize}`;
      const fullUrl =
        searchQuery.length >= 3
          ? `${baseUrl}&search=${encodeURIComponent(searchQuery)}`
          : baseUrl;
    const response = await GetChat(fullUrl);
    if(response?.status===200){
      const userData=response?.data?.data || [];
      const mappedRows = userData.map((user: any, index: number) => ({
        id: index + 1 + page * pageSize,
        email: user?.["email"] || "----",  
        role: user?.role,
        username: user?.username || "----",
        user_id: user?.["id"] || "----",
       
      }));
      setRows(mappedRows); 
      setTotalCount(response?.data?.total || 0);
    }  
  } catch (error) {
    console.error("Error fetching certifications:", error);
  } finally {
    setProjectLoading(false);
  }
}

const getCertifications=async(searchQuery="")=>{
  try {
    setProjectLoading(true);
     const baseUrl = `${networkUrls.certifications}?page=${page + 1
        }&page_size=${pageSize}`;
      const fullUrl =
        searchQuery.length >= 3
          ? `${baseUrl}&search=${encodeURIComponent(searchQuery)}`
          : baseUrl;
    const response = await Get(fullUrl, true);
    if(response?.status===200){
      const certData=response?.data?.data || [];
      const mappedRows = certData.map((cert: any, index: number) => ({
        id: index + 1 + page * pageSize,
        certification_name: cert?.["certification_name"] || "----",     
        count: cert?.["count"] || "----",
        certificate_id: cert?.["id"] || "----",
      }));
      setRows(mappedRows); 
      setTotalCount(response?.data?.total || 0);
    }  
  } catch (error) {
    console.error("Error fetching certifications:", error);
  } finally {
    setProjectLoading(false);
  }
}

const getAllVideos = async (searchQuery = "") => {
  try {
    setProjectLoading(true);
    const baseUrl = `${networkUrls.getAllVideos}?page=${page + 1}&page_size=${pageSize}`;
    const fullUrl =
      searchQuery.length >= 2
        ? `${baseUrl}&search=${encodeURIComponent(searchQuery)}`
        : baseUrl;

    const response = await Get(fullUrl, true);

    if (response?.status === 200) {
      const videos = response?.data?.videos || response?.data?.data || [];
      setTotalCount(response?.data?.total || videos.length);

      const mappedRows = videos.map((video: any, index: number) => ({
        id: index + 1 + page * pageSize,
        video_id: video?.doc_id || video?.id || video?.video_id || "----",
        video_name: video?.filename || video?.name || video?.video_name || "----",
        uploaded_at: video?.uploaded_at || video?.created_at || "----",
      }));
      setRows(mappedRows);
    }
  } catch (error) {
    console.error("Error fetching videos:", error);
  } finally {
    setProjectLoading(false);
  }
};
  useEffect(() => {
    const shouldSearch = debouncedSearch.length >= 3 || searchText.length < 3;
    if (shouldSearch) {
    if(type==="industry-track"){
        getIndustryTrack(shouldSearch ? debouncedSearch : "")
    }
    else if(type==="certifications"){
        getCertifications(shouldSearch ? debouncedSearch : "");
    }
    else if(type==="videos"){
        getAllVideos(shouldSearch ? debouncedSearch : "");
    }
    else if(type==="users"){
        getUsers(shouldSearch ? debouncedSearch : "");
    }
    else{
        getProjectDocuments(shouldSearch ? debouncedSearch : "");
      }
    }
  }, [debouncedSearch, page, pageSize, triggerGetCall, type]);


  const handleEditCertification=(params:any)=>{
    setData(params.row);
    setOpen({isOpen:true,type:"edit"});

  }

  const handleDelete=(params:any)=>{
    setData(params.row);
    setOpen({isOpen:true,type:"delete"});

  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchText.trim());
    }, 400);
    return () => clearTimeout(handler);
  }, [searchText]);

const getColumns = () => {
  if (type === "industry-track") {
    return [
      { field: "industry_name", headerName: "Industry Name", flex: 1, minWidth: 200 },
      { field: "manager", headerName: "Manager", flex: 1, minWidth: 200 },
      // { field: "spoc1", headerName: "SPOC 1", flex: 1, minWidth: 150 },
      // { field: "spoc2", headerName: "SPOC 2", flex: 1, minWidth: 150 },
      // { field: "spoc3", headerName: "SPOC 3", flex: 1, minWidth: 150 },
      // {
      //   field: "members",
      //   headerName: "Members",
      //   flex: 1,
      //   minWidth: 250,
      //   renderCell: (params: any) => (params.row.members?.length ? params.row.members.join(", ") : "----"),
      // },
      {
      field: "actions",
      headerName: "View",
      width: 100,
      sortable: false,
      renderCell: (params: any) => (
        <IconButton
          onClick={() => navigate(`/industry-track-details/${params.row.industry_track_id}`)}
          title="View Details"
          sx={{color:"#4D8FAC"}}
        >
          <VisibilityIcon />
        </IconButton>
      ),
    },
    ];
  }
 else if(type==="certifications"){ 

  return [
    { field: "certification_name", headerName: "Certification Name", flex: 1, minWidth: 200 },
    { field: "count", headerName: "Count", flex: 1, minWidth: 100 },
   {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      renderCell: (params: any) => (
        <>
        <IconButton
        onClick={()=>handleEditCertification(params)}
          title="Edit"
          sx={{color:"#4D8FAC"}}
        >
          <EditIcon style={{width:"0.5rem"}} />
        </IconButton>

        <IconButton
          onClick={()=>handleDelete(params)}
          title="Delete"
          sx={{color:"#4D8FAC"}}
        >
          <DeleteIcon />
        </IconButton>

        </>
        
      ),
    },
  ]
  }
  else if(type==="videos"){
    return [
      { field: "video_name", headerName: "Video Name", flex: 1, minWidth: 200 },
      {
        field: "actions",
        headerName: "View",
        width: 100,
        sortable: false,
        renderCell: (params: any) => (
          <IconButton
            onClick={() => navigate(`/video-details/${params.row.video_id}`)}
            title="View Details"
          >
            <VisibilityIcon />
          </IconButton>
        ),
      },
    ];
  }
 else if(type==="users"){ 

  return [
    { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
    { field: "username", headerName: "Username", flex: 1, minWidth: 100 },
    { field: "role", headerName: "Role", flex: 1, minWidth: 100 },
   {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      renderCell: (params: any) => (
        <>
        <IconButton
        onClick={()=>handleEditCertification(params)}
          title="Edit"
          sx={{color:"#4D8FAC"}}
        >
          <EditIcon />
        </IconButton>

        <IconButton
          onClick={()=>handleDelete(params)}
          title="Delete"
          sx={{color:"#4D8FAC"}}
        >
          <DeleteIcon />
        </IconButton>

        </>
        
      ),
    },
  ]
  }
  // Default → project documents
  return [
    { field: "filename", headerName: "File Name", flex: 1, minWidth: 200 },
    { field: "clientname", headerName: "Client Name", flex: 1, minWidth: 100 },
    {
      field: "actions",
      headerName: "View",
      width: 100,
      sortable: false,
      renderCell: (params: any) => (
        <IconButton
          onClick={() => navigate(`/documents-details/${params.row.doc_id}`)}
          title="View Details"
          sx={{color:"#4D8FAC"}}
        >
          <VisibilityIcon />
        </IconButton>
      ),
    },
  ];
};


  const totalPages = Math.ceil(totalCount / pageSize);

  const handleAdd=()=>{
    if(type==="certifications"){

      setOpen({isOpen:true,type:"add"});
    }
    else if(type==="users"){

      setOpen({isOpen:true,type:"add"});
    }
    
    else{
      setOpen(true);
    }
  }

  return (
    <Box>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginTop: "20px", marginBottom: "10px", paddingLeft: "3px" }}
      >
        <Grid sx={{ display: "flex", alignItems: "center", gap: 2 ,marginBottom:"0px"}}>
        <Typography component="label" fontWeight="bold" style={{ color: "black" }}>
          {tableName}
        </Typography>
     {type!=="documents" && type!=="videos" &&    <Button endIcon={<AddIcon/>} variant="contained" sx={{backgroundColor:"#4D8FAC",height:"34px"}} onClick={handleAdd} className="add-btn">Add</Button>}
        </Grid>
       
        <Input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          startDecorator={<SearchIcon sx={{ color: "white" }} />}
          placeholder="Search..."
          size="md"
          variant="soft"
          sx={{
            width: 300,
            backgroundColor: "#4D8FAC",
            color: "white",
            borderRadius: "10px",
            boxShadow: "sm",
            "& input": {
              color: "white",
            },
            "&::placeholder": {
              color: "white",
              opacity: 0.8,
            },
          }}
        />
      </Grid>

      {isMobile ? (
        <Box>
          {projectsLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="200px"
            >
              <CircularProgress />
            </Box>
          ) : rows.length === 0 ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="200px"
            >
              <Typography variant="h6" color="text.secondary">
                {type === "videos" ? "No videos found" : type === "industry-track" ? "No industry tracks found" : type === "certifications" ? "No certifications found" : type === "users" ? "No users found" : "No documents found"}
              </Typography>
            </Box>
          ) : (
            <>
              {rows.map((row:any) => (
                <Card
                  key={row.id}
                  sx={{
                    marginBottom: 2,
                    padding: 2,
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={1}
                  >
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      {type === "certifications" ? (
                        <>
                          <Typography
                            variant="subtitle1"
                            fontWeight="600"
                            color="#333"
                            sx={{
                              marginBottom: "4px",
                              wordBreak: "break-word",
                            }}
                          >
                            {row.certification_name || "----"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ wordBreak: "break-word" }}
                          >
                            Count: {row.count || "----"}
                          </Typography>
                        </>
                      ) : type === "users" ? (
                        <>
                          <Typography
                            variant="subtitle1"
                            fontWeight="600"
                            color="#333"
                            sx={{
                              marginBottom: "4px",
                              wordBreak: "break-word",
                            }}
                          >
                            {row.email || "----"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ wordBreak: "break-word", marginBottom: "2px" }}
                          >
                            Username: {row.username || "----"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ wordBreak: "break-word" }}
                          >
                            Role: {row.role || "----"}
                          </Typography>
                        </>
                      ) : type === "industry-track" ? (
                        <>
                          <Typography
                            variant="subtitle1"
                            fontWeight="600"
                            color="#333"
                            sx={{
                              marginBottom: "4px",
                              wordBreak: "break-word",
                            }}
                          >
                            {row.industry_name || "----"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ wordBreak: "break-word" }}
                          >
                            Manager: {row.manager || "----"}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="subtitle1"
                            fontWeight="600"
                            color="#333"
                            sx={{
                              marginBottom: "4px",
                              wordBreak: "break-word",
                            }}
                          >
                            {row.video_name
                              ? row.video_name
                              : row.filename
                              ? row.filename
                              : row.project_name}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ wordBreak: "break-word" }}
                          >
                            {row.clientname
                              ? row.clientname
                              : row.project_manager}
                          </Typography>
                        </>
                      )}
                    </Box>
                    <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                      {type === "certifications" || type === "users" ? (
                        <>
                          <IconButton
                            onClick={() => handleEditCertification({ row })}
                            title="Edit"
                            sx={{
                              backgroundColor: "#4D8FAC",
                              color: "white",
                              "&:hover": { backgroundColor: "#3b738a" },
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => handleDelete({ row })}
                            title="Delete"
                            sx={{
                              backgroundColor: "#d32f2f",
                              color: "white",
                              "&:hover": { backgroundColor: "#b71c1c" },
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      ) : type === "industry-track" ? (
                        <IconButton
                          onClick={() => navigate(`/industry-track-details/${row.industry_track_id}`)}
                          title="View Details"
                          sx={{
                            backgroundColor: "#4D8FAC",
                            color: "white",
                            "&:hover": { backgroundColor: "#3b738a" },
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={() => {
                            if (type === "videos" && row.video_id) {
                              navigate(`/video-details/${row.video_id}`);
                            } else if (row.doc_id) {
                              navigate(`/documents-details/${row.doc_id}`);
                            }
                          }}
                          title={type === "videos" ? "View Video" : "View Document"}
                          sx={{
                            backgroundColor: "#4D8FAC",
                            color: "white",
                            "&:hover": { backgroundColor: "#3b738a" },
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </Card>
              ))}

              <Stack direction="row" justifyContent="space-between" alignItems="center" mt={2}>
                <Button
                  variant="outlined"
                  disabled={page === 0}
                  onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                >
                  Previous
                </Button>
                <Typography variant="body2">
                  Page {page + 1} of {totalPages}
                </Typography>
                <Button
                  variant="outlined"
                  disabled={page + 1 >= totalPages}
                  onClick={() => setPage((prev) => prev + 1)}
                >
                  Next
                </Button>
              </Stack>
            </>
          )}
        </Box>
      ) : (
        <div style={{ minHeight: 100, width: "100%" }}>
          {projectsLoading  ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="200px"
            >
              <CircularProgress />
            </Box>
          )  : (
            <DataGrid
              rows={rows}
              columns={getColumns()}
              rowCount={totalCount}
              paginationMode="server"
              paginationModel={{ page, pageSize }}
              onPaginationModelChange={(model) => {
                setPage(model.page);
                setPageSize(model.pageSize);
              }}
               localeText={{
    noRowsLabel: "No data available",
    footerRowSelected: (count) =>
      `${count.toLocaleString()} row(s) selected`,
    toolbarDensity: "Row Height",
    toolbarDensityLabel: "Density",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comfortable",
    MuiTablePagination: {
      labelRowsPerPage: "Rows per page:",
    },
  }}
              sx={{
              "--DataGrid-containerBackground": "#4D8FAC",
              "& .MuiDataGrid-columnHeaders": {
                color: "#fff",  
                fontWeight: "bold",
              },
            }}
              loading={projectsLoading}
              pageSizeOptions={[5, 10, 20]}
              disableRowSelectionOnClick
            />
          )}
        </div>
      )}
    </Box>
  );
};

export default DocumentsTable;